import React, { useState, useEffect } from 'react';
import api from '../api';

const SERVICES = [
  { value: 'openai_gpt', label: 'GPT-4o-mini', cat: 'ai' },
  { value: 'openai_tts', label: 'TTS-1', cat: 'ai' },
  { value: 'firebase_functions', label: 'Cloud Functions', cat: 'cloud' },
  { value: 'firebase_firestore', label: 'Firestore', cat: 'cloud' },
  { value: 'firebase_storage', label: 'Storage', cat: 'cloud' },
  { value: 'places_api', label: 'Places API', cat: 'cloud' },
  { value: 'hetzner', label: 'Hetzner', cat: 'server' },
];

const SOURCES = [
  { value: 'ios_iap', label: 'iOS IAP' },
  { value: 'android_iap', label: 'Android IAP' },
  { value: 'b2b_sponsor', label: 'B2B Szponzor' },
];

const PRODUCTS = ['starter', 'explorer', 'traveler', 'sponsor_szolnok'];

function today() { return new Date().toISOString().split('T')[0]; }

export default function Admin() {
  const [msg, setMsg] = useState('');
  const [fetchResult, setFetchResult] = useState(null);

  // 🆕 Sprint 1: SMTP + alert beállítások
  const [settings, setSettings] = useState({});
  const [savingSettings, setSavingSettings] = useState(false);
  const [settingsMsg, setSettingsMsg] = useState('');
  const [testEmailTo, setTestEmailTo] = useState('');
  const [testEmailBusy, setTestEmailBusy] = useState(false);
  const [emailHistory, setEmailHistory] = useState([]);

  useEffect(() => {
    api.settings.get().then(s => {
      setSettings(s);
      if (!testEmailTo && s['alerts.recipients']) {
        try { const arr = JSON.parse(s['alerts.recipients']); if (arr[0]) setTestEmailTo(arr[0]); } catch (e) {}
      }
    }).catch(() => {});
    api.settings.emailHistory(20).then(setEmailHistory).catch(() => {});
  }, []);

  const updateSetting = (k, v) => setSettings(prev => ({ ...prev, [k]: v }));

  // 🔴 (2026-09) A riasztás-kapcsolók eddig CSAK a helyi állapotot állították, és
  //   a mentés a táblázat FÖLÖTT lévő „💾 Mentés" gombra várt — ami a kapcsolóra
  //   kattintáskor már kigörgött a képernyőről. Aki kikapcsolta a napi emailt és
  //   nem görgetett vissza, annak az újratöltésnél visszaugrott bekapcsoltra, és
  //   a levél másnap is megjött. Egy kapcsoló attól kapcsoló, hogy azonnal hat.
  const saveOne = async (k, v) => {
    const prev = settings[k];
    updateSetting(k, v);
    setSettingsMsg('');
    try {
      await api.settings.save({ [k]: v });
      setSettingsMsg('✅ Mentve');
    } catch (err) {
      // Ne maradjon a felületen olyan állapot, ami valójában nem mentődött el.
      updateSetting(k, prev);
      setSettingsMsg('❌ Nem sikerült menteni: ' + (err.message || 'hiba'));
    }
  };
  const saveSettings = async () => {
    setSavingSettings(true); setSettingsMsg('');
    try {
      // Csak az általunk szerkeszthető kulcsokat küldjük (a _configured-t nem)
      const toSend = {};
      Object.keys(settings).forEach(k => { if (!k.startsWith('_')) toSend[k] = settings[k]; });
      await api.settings.save(toSend);
      setSettingsMsg('✅ Mentve');
      // újratöltjük, hogy a maszkolt jelszó "••••" formára visszaálljon
      const fresh = await api.settings.get();
      setSettings(fresh);
    } catch (err) {
      setSettingsMsg('❌ ' + (err.message || 'hiba'));
    } finally { setSavingSettings(false); }
  };
  const sendTestEmail = async () => {
    if (!testEmailTo) return;
    setTestEmailBusy(true); setSettingsMsg('');
    try {
      await api.settings.testEmail(testEmailTo);
      setSettingsMsg('✅ Teszt email elküldve ide: ' + testEmailTo);
      const h = await api.settings.emailHistory(20); setEmailHistory(h);
    } catch (err) {
      setSettingsMsg('❌ ' + (err.message || 'sikertelen'));
    } finally { setTestEmailBusy(false); }
  };

  // Cost form
  const [costDate, setCostDate] = useState(today());
  const [costService, setCostService] = useState('openai_tts');
  const [costAmount, setCostAmount] = useState('');

  // Revenue form
  const [revDate, setRevDate] = useState(today());
  const [revSource, setRevSource] = useState('ios_iap');
  const [revProduct, setRevProduct] = useState('starter');
  const [revAmount, setRevAmount] = useState('');
  const [revTx, setRevTx] = useState('');

  const flash = (m) => { setMsg(m); setTimeout(() => setMsg(''), 3000); };

  const submitCost = async () => {
    const svc = SERVICES.find(s => s.value === costService);
    await api.manual.cost({ date: costDate, service: costService, category: svc.cat, amount_usd: parseFloat(costAmount) });
    flash(`Költség mentve: ${svc.label} $${costAmount}`);
    setCostAmount('');
  };

  const submitRevenue = async () => {
    await api.manual.revenue({ date: revDate, source: revSource, product: revProduct, amount_usd: parseFloat(revAmount), transactions: parseInt(revTx) || 0 });
    flash(`Bevétel mentve: $${revAmount}`);
    setRevAmount(''); setRevTx('');
  };

  const triggerFetch = async () => {
    setFetchResult(null);
    flash('Adatgyűjtés indítva...');
    const r = await api.manual.triggerFetch();
    setFetchResult(r);
  };

  return (
    <div>
      <h1 style={{ fontSize: 22, fontWeight: 700, marginBottom: 20 }}>Admin</h1>

      {msg && <div style={{ background: 'rgba(0,212,255,0.15)', color: '#00d4ff', padding: '10px 16px', borderRadius: 8, marginBottom: 16, fontSize: 13 }}>{msg}</div>}

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 24 }}>
        {/* Költség */}
        <div className="card">
          <h3 style={{ fontSize: 15, color: '#8b8fa3', marginBottom: 12 }}>Költség hozzáadása</h3>
          <div style={styles.form}>
            <input type="date" value={costDate} onChange={e => setCostDate(e.target.value)} />
            <select value={costService} onChange={e => setCostService(e.target.value)}>
              {SERVICES.map(s => <option key={s.value} value={s.value}>{s.label}</option>)}
            </select>
            <input type="number" step="0.01" placeholder="Összeg (USD)" value={costAmount} onChange={e => setCostAmount(e.target.value)} />
            <button className="btn" onClick={submitCost} disabled={!costAmount}>Mentés</button>
          </div>
        </div>

        {/* Bevétel */}
        <div className="card">
          <h3 style={{ fontSize: 15, color: '#8b8fa3', marginBottom: 12 }}>Bevétel hozzáadása</h3>
          <div style={styles.form}>
            <input type="date" value={revDate} onChange={e => setRevDate(e.target.value)} />
            <select value={revSource} onChange={e => setRevSource(e.target.value)}>
              {SOURCES.map(s => <option key={s.value} value={s.value}>{s.label}</option>)}
            </select>
            <select value={revProduct} onChange={e => setRevProduct(e.target.value)}>
              {PRODUCTS.map(p => <option key={p} value={p}>{p}</option>)}
            </select>
            <input type="number" step="0.01" placeholder="Összeg (USD)" value={revAmount} onChange={e => setRevAmount(e.target.value)} />
            <input type="number" placeholder="Tranzakciók" value={revTx} onChange={e => setRevTx(e.target.value)} />
            <button className="btn" onClick={submitRevenue} disabled={!revAmount}>Mentés</button>
          </div>
        </div>
      </div>

      {/* Fetch trigger */}
      <div className="card" style={{ marginBottom: 16 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <h3 style={{ fontSize: 15, color: '#8b8fa3' }}>Adatgyűjtés indítása</h3>
            <p style={{ fontSize: 12, color: '#8b8fa3', marginTop: 4 }}>Azonnal lefuttatja az összes API lekérést (tegnapi napra)</p>
          </div>
          <button className="btn" onClick={triggerFetch}>Futtatás</button>
        </div>
        {fetchResult && (
          <div style={{ marginTop: 12, fontSize: 13 }}>
            <div style={{ color: '#8b8fa3', marginBottom: 8 }}>Dátum: {fetchResult.date}</div>
            {fetchResult.results?.map((r, i) => (
              <div key={i} style={{ display: 'flex', gap: 8, marginBottom: 4 }}>
                <span style={{ color: r.ok ? '#34d399' : '#f87171' }}>{r.ok ? '✓' : '✗'}</span>
                <span>{r.name}</span>
                {r.error && <span style={{ color: '#f87171', fontSize: 11 }}>{r.error}</span>}
              </div>
            ))}
          </div>
        )}
      </div>

      {/* 🆕 SMTP beállítás */}
      <div className="card" style={{ marginBottom: 16 }}>
        <h3 style={{ fontSize: 15, color: '#8b8fa3', marginBottom: 12 }}>📧 SMTP email beállítás</h3>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 10 }}>
          <label style={{ fontSize: 12 }}>
            <div style={{ color: '#8b8fa3', marginBottom: 4 }}>SMTP host</div>
            <input value={settings['smtp.host'] || ''} onChange={e => updateSetting('smtp.host', e.target.value)}
              placeholder="smtp.example.com"
              style={{ width: '100%', padding: 8, background: '#0f1428', color: '#e4e6ed', border: '1px solid #252b4a', borderRadius: 4 }} />
          </label>
          <label style={{ fontSize: 12 }}>
            <div style={{ color: '#8b8fa3', marginBottom: 4 }}>Port</div>
            <input value={settings['smtp.port'] || ''} onChange={e => updateSetting('smtp.port', e.target.value)}
              placeholder="587 (STARTTLS) vagy 465 (TLS)"
              style={{ width: '100%', padding: 8, background: '#0f1428', color: '#e4e6ed', border: '1px solid #252b4a', borderRadius: 4 }} />
          </label>
          <label style={{ fontSize: 12 }}>
            <div style={{ color: '#8b8fa3', marginBottom: 4 }}>Felhasználónév</div>
            <input value={settings['smtp.user'] || ''} onChange={e => updateSetting('smtp.user', e.target.value)}
              autoComplete="off"
              style={{ width: '100%', padding: 8, background: '#0f1428', color: '#e4e6ed', border: '1px solid #252b4a', borderRadius: 4 }} />
          </label>
          <label style={{ fontSize: 12 }}>
            <div style={{ color: '#8b8fa3', marginBottom: 4 }}>Jelszó</div>
            <input type="password" value={settings['smtp.password'] || ''}
              onChange={e => updateSetting('smtp.password', e.target.value)}
              placeholder="(változatlan, ha a mező maszkolt marad)" autoComplete="new-password"
              style={{ width: '100%', padding: 8, background: '#0f1428', color: '#e4e6ed', border: '1px solid #252b4a', borderRadius: 4 }} />
          </label>
          <label style={{ fontSize: 12 }}>
            <div style={{ color: '#8b8fa3', marginBottom: 4 }}>Feladó (From cím)</div>
            <input value={settings['smtp.from'] || ''} onChange={e => updateSetting('smtp.from', e.target.value)}
              placeholder="AI TourMate &lt;noreply@aitourmate.hu&gt;"
              style={{ width: '100%', padding: 8, background: '#0f1428', color: '#e4e6ed', border: '1px solid #252b4a', borderRadius: 4 }} />
          </label>
          <label style={{ fontSize: 12 }}>
            <div style={{ color: '#8b8fa3', marginBottom: 4 }}>TLS módszer</div>
            <select value={settings['smtp.secure'] || 'false'} onChange={e => updateSetting('smtp.secure', e.target.value)}
              style={{ width: '100%', padding: 8, background: '#0f1428', color: '#e4e6ed', border: '1px solid #252b4a', borderRadius: 4 }}>
              <option value="false">STARTTLS (port 587, általában ez)</option>
              <option value="true">implicit TLS (port 465)</option>
            </select>
          </label>
        </div>

        <div style={{ marginTop: 14 }}>
          <div style={{ fontSize: 12, color: '#8b8fa3', marginBottom: 4 }}>📬 Címzettek (a riportokhoz, vesszővel elválasztva)</div>
          <input
            value={(() => { try { return JSON.parse(settings['alerts.recipients'] || '[]').join(', '); } catch (e) { return settings['alerts.recipients'] || ''; } })()}
            onChange={e => {
              const arr = e.target.value.split(',').map(s => s.trim()).filter(Boolean);
              updateSetting('alerts.recipients', JSON.stringify(arr));
            }}
            placeholder="te@pelda.hu, masik@pelda.hu"
            style={{ width: '100%', padding: 8, background: '#0f1428', color: '#e4e6ed', border: '1px solid #252b4a', borderRadius: 4, fontSize: 13 }} />
        </div>

        <div style={{ display: 'flex', gap: 10, marginTop: 14, flexWrap: 'wrap', alignItems: 'center' }}>
          <button className="btn" onClick={saveSettings} disabled={savingSettings}>{savingSettings ? 'Mentés...' : '💾 Mentés'}</button>
          <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
            <input value={testEmailTo} onChange={e => setTestEmailTo(e.target.value)} placeholder="teszt@pelda.hu"
              style={{ padding: 8, background: '#0f1428', color: '#e4e6ed', border: '1px solid #252b4a', borderRadius: 4, width: 200 }} />
            <button className="btn" onClick={sendTestEmail} disabled={testEmailBusy || !testEmailTo}>
              {testEmailBusy ? 'Küldés...' : '✉️ Teszt email'}
            </button>
          </div>
          {settingsMsg && <div style={{ color: settingsMsg.startsWith('✅') ? '#34d399' : '#f87171', fontSize: 13 }}>{settingsMsg}</div>}
        </div>
        {settings._configured === false && (
          <div style={{ marginTop: 10, fontSize: 12, color: '#fbbf24' }}>
            ⚠️ Az SMTP még nincs teljesen beállítva. Adj meg host / port / user / jelszó / from értéket, majd mentés után tesztelj.
          </div>
        )}
      </div>

      {/* 🆕 Riasztások és napi riport */}
      <div className="card" style={{ marginBottom: 16 }}>
        <h3 style={{ fontSize: 15, color: '#8b8fa3', marginBottom: 12 }}>🚨 Riasztások és napi riport</h3>
        <table style={{ width: '100%', fontSize: 13, borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ color: '#8b8fa3', textAlign: 'left', borderBottom: '1px solid #252b4a' }}>
              <th style={{ padding: '6px 4px' }}>Funkció</th>
              <th style={{ padding: '6px 4px', textAlign: 'center' }}>Bekapcsolva</th>
              <th style={{ padding: '6px 4px' }}>Küszöb</th>
              <th style={{ padding: '6px 4px' }}>Leírás</th>
            </tr>
          </thead>
          <tbody>
            {[
              { key: 'alerts.daily_report', label: '🌅 Napi AI riport (6:30)', thresholdKey: 'alerts.daily_report.hours', thresholdLabel: 'óra (visszamenőleg)', desc: 'Minden reggel 6:30-kor lefuttatja az AI log elemzőt és emailben elküldi.' },
              { key: 'alerts.cost_spike', label: '💸 Cost spike', thresholdKey: 'alerts.cost_spike.multiplier', thresholdLabel: '× átlag fölött', desc: 'Riaszt, ha a mai költség (vetítve) X-szerese az utolsó 7 nap átlagának.' },
              { key: 'alerts.error_rate', label: '🚨 Error rate ugrás', thresholdKey: 'alerts.error_rate.multiplier', thresholdLabel: '× óránkénti átlag', desc: 'Riaszt, ha az utolsó 1 óra hibái meghaladják az átlag X-szeresét.' },
              { key: 'alerts.wikivoyage_drop', label: '🗺️ Wikivoyage hit-rate', thresholdKey: 'alerts.wikivoyage_drop.threshold', thresholdLabel: '% alatt', desc: 'Riaszt, ha az utolsó 6 óra Wikivoyage hit-rate-je a megadott % alá esik.' },
            ].map(row => (
              <tr key={row.key} style={{ borderBottom: '1px solid #252b4a' }}>
                <td style={{ padding: '8px 4px', fontWeight: 600 }}>{row.label}</td>
                <td style={{ padding: '8px 4px', textAlign: 'center' }}>
                  <input type="checkbox"
                    checked={settings[row.key + '.enabled'] === 'true'}
                    onChange={e => saveOne(row.key + '.enabled', e.target.checked ? 'true' : 'false')} />
                </td>
                <td style={{ padding: '8px 4px' }}>
                  <input value={settings[row.thresholdKey] || ''}
                    onChange={e => updateSetting(row.thresholdKey, e.target.value)}
                    style={{ width: 60, padding: 4, background: '#0f1428', color: '#e4e6ed', border: '1px solid #252b4a', borderRadius: 4 }} />
                  <span style={{ color: '#8b8fa3', fontSize: 11, marginLeft: 6 }}>{row.thresholdLabel}</span>
                </td>
                <td style={{ padding: '8px 4px', color: '#8b8fa3', fontSize: 12 }}>{row.desc}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <div style={{ marginTop: 10, fontSize: 11, color: '#8b8fa3' }}>
          A kapcsolók <b>azonnal mentődnek</b> — nem kell a Mentés gombra kattintani. A küszöbértékek módosításához viszont igen. A debouncing miatt minden riasztás max. 1×/nap megy ki azonos kulccsal.
        </div>
      </div>

      {/* 🆕 Email napló */}
      <div className="card" style={{ marginBottom: 16 }}>
        <h3 style={{ fontSize: 15, color: '#8b8fa3', marginBottom: 12 }}>📨 Email napló (utolsó 20)</h3>
        {emailHistory.length === 0 ? (
          <div style={{ color: '#8b8fa3', fontSize: 13 }}>Még nem küldött ki emailt a dashboard.</div>
        ) : (
          <table style={{ width: '100%', fontSize: 12, borderCollapse: 'collapse' }}>
            <thead><tr style={{ color: '#8b8fa3', textAlign: 'left', borderBottom: '1px solid #252b4a' }}>
              <th style={{ padding: '6px 4px' }}>Időpont</th>
              <th style={{ padding: '6px 4px' }}>Típus</th>
              <th style={{ padding: '6px 4px' }}>Címzett</th>
              <th style={{ padding: '6px 4px' }}>Tárgy</th>
              <th style={{ padding: '6px 4px' }}>Státusz</th>
            </tr></thead>
            <tbody>
              {emailHistory.map(e => (
                <tr key={e.id} style={{ borderBottom: '1px solid #252b4a' }}>
                  <td style={{ padding: '4px', whiteSpace: 'nowrap' }}>{e.sent_at}</td>
                  <td style={{ padding: '4px' }}>{e.type}</td>
                  <td style={{ padding: '4px' }}>{e.to_addr}</td>
                  <td style={{ padding: '4px', color: '#8b8fa3' }}>{e.subject}</td>
                  <td style={{ padding: '4px', color: e.success ? '#34d399' : '#f87171' }}>
                    {e.success ? '✓' : '✗ ' + (e.error || '')}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

const styles = {
  form: { display: 'flex', flexDirection: 'column', gap: 8 },
};
